import React from "react";
import { Button, Grid, Modal, Typography } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import Correct from "../../images/Correct.svg";
import Incorrect from "../../images/Incorrect.svg";
import styles from "./styles";
import "animate.css/animate.css";

const EvaluatorModal = ({
  classes,
  nextQuestion,
  answeredCorrectly,
  question,
}) => {
  return (
    <Modal open={true}>
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ height: "100vh" }}
      >
        <Grid className={`${classes.evaluatorModalContainer}`}>
          <Grid container justify="center">
            {answeredCorrectly ? (
              <img
                alt=""
                src={Correct}
                className={classes.correctIncorrectIcon}
              />
            ) : (
              <img
                alt=""
                src={Incorrect}
                className={classes.correctIncorrectIcon}
              />
            )}
          </Grid>
          <Typography className={classes.evalDesc}>
            {question.description}
            {/* {answeredCorrectly
              ? question.rightAnswerText
              : question.wrongAnswerText} */}
          </Typography>
          <Grid container justify="center">
            <Button className={classes.submitButton} onClick={nextQuestion}>
              NEXT
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default withStyles(styles)(EvaluatorModal);
